module.exports = __webpack_public_path__ + "static/media/ODS13.5d7ae912.jpg";